import React from 'react'
import { Container } from 'reactstrap'
import Breadcrumbs from "../../components/Common/Breadcrumb";


const ViewProject = () => {
  return (
    <React.Fragment>
        <div className='page-content'>
            <Container fluid>
            <Breadcrumbs
                title={"Dashboards"}
                breadcrumbItem={"View Project"}
            />
            </Container>
        </div>
    </React.Fragment>
  )
}

export default ViewProject